import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../../src/Layout/Layout";
import { InputField } from "../../../../../src/Components/formElements/InputField";

import ItemServiceV2 from "../../../../../src/services/logistics_appCommonService";
import ItemService from "../../../../services/supplier_appCommonService";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../../src/common/Validations";
import FailureModal from "../../../../../src/Components/Modal/supplier_app/FailureModal";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import { useReactToPrint } from "react-to-print";
import PrintGatePass from "./PrintGatePass";

const GateEntryUpdate = () => {
  //Customer ID
  localStorage.setItem("menu", "GateEntry");
  localStorage.setItem("submenu", "Inward/Outward");
  let customerID = useSelector((state) => state?.customer?.customerID);

  // Add Print Ref
  const printGatePassRef = useRef(null);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  const [getGateEntryDetails, setGateEntryDetails] = useState([]);
  const [getGateUpdate, setGateUpdate] = useState();
  const [, /*selectedDropdown*/ setSelectedDropdown] = useState("");
  // const [getCustomer /*setCustomer*/] = useState([]);

  const navigate = useNavigate();
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  /* pop failure modal data*/
  const failureCashRequestUpdate = {
    title: "Warning",
    ErrorMsg: "",
  };
  const editMode = true;

  const [getFailureCashRequestUpdate] = useState(failureCashRequestUpdate);

  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState("");
  const [poItems, setPOItems] = useState([]);

  const [formInputs, setFormInputs] = useState({
    gateCode: "",
    purchasingDocumentNr: "",
    inDate: getTodaysData() || "",
    gateInwardSelectedTime: "",
    inNextHour: "",
    inCustomerName: "",
    inVehicleNumber: "",
    inDriverName: "",
    inDriverMobileNumber: "",
    inVehicleType: "",
    inProceedWeighBridge: "",
    inLoadingBay: "",
    inLoadingPoints: "",
    inWeighbridge: "",
    inWeighbridgeName: "",

    gateTransportRequestNumber: "",
    outPass: "",
    gateOutWardDate: "",
    gateOutWardTime: "",
    outRemark: "",
    outNextHour: "",
    outVehicleType: "",
    outProceedWeighBridge: "",
    outVehicleNumber: "",
    outDriverName: "",
    outDriverMobileNumber: "",
    outLoadingBay: "",
    outLoadingPoints: "",
    outWeighbridge: "",

    invoiceNumber: "",
    deliveryChallanNumber: "",
    ewayBillNumber: "",

    invoiceAttachmentId: "",
    deliveryChallanAttachmentId: "",
    ewayBillAttachmentId: "",
  });

  //Validations
  const [validation, setValidation] = useState({});
  const typeOfOutpass = [
    { id: 1, name: "Yes" }, //red
    { id: 2, name: "No" }, //yellow
  ];
  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {}; // Add validations here if needed
    setFormInputs((prev) => ({ ...prev, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const handleEwayBillUpload = (response) => {
    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        ewayBillAttachmentId: response.attachmentId,
      }));

      toast.success("E-way Bill uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  // File Upload Handlers
  const handleInvoiceUpload = (response) => {
    console.log("Invoice Upload Response:", response);

    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        invoiceAttachmentId: response.attachmentId,
      }));

      toast.success(response?.message || "Invoice uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    } else {
      toast.error("Invoice upload failed", {
        duration: 3000,
        position: "top-right",
      });
    }
  };

  const handleDeliveryChallanUpload = (response) => {
    if (response?.attachmentId) {
      setFormInputs((prev) => ({
        ...prev,
        deliveryChallanAttachmentId: response.attachmentId,
      }));

      toast.success("Delivery Challan uploaded successfully", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  // File Viewer Handlers
  const handleViewFile = (fileAttachmentId) => {
    if (fileAttachmentId) {
      setFileViewData(fileAttachmentId);
      setShowFileViewModal(true);
    } else {
      toast.error("No file to view", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
    setFileViewData("");
  };

  // const handlePrintGatePass = useReactToPrint({
  //   contentRef: printGatePassRef, // Changed from 'content' to 'contentRef'
  //   documentTitle: `Gate_Pass_${formInputs?.gateCode || customerID}`,
  //   onAfterPrint: () => {
  //     toast.success("Gate Pass printed successfully!", {
  //       duration: 2000,
  //       position: "top-right",
  //     });
  //   },
  // });

  useEffect(() => {
    if (!getDropdownData) return;

    // console.log(">>Check getDropdownData Data", getDropdownData);

    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
    }));

    setSelectedDropdown(getDropdownData?.textField);
  }, [getDropdownData]);

  //Get cash request API
  useEffect(() => {
    gateUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const gateUpdate = async () => {
    let obj = {
      documentNumber: customerID,
    };
    await ItemServiceV2.getGateEntryDatails(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        // console.log(">>PO data", item?.data);
        setGateEntryDetails(item?.data);

        if (item?.data[0]?.items) {
          setPOItems(item.data[0].items);
        }
      } else {
        setGateEntryDetails([]);
        setPOItems([]); // Reset if error
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };
  useEffect(() => {
    if (getGateEntryDetails.length > 0) {
      setFormInputs((prev) => ({
        ...prev,
        ...getGateEntryDetails[0],
      }));
    }
  }, [getGateEntryDetails]);

  useEffect(() => {
    if (formInputs) {
      setGateUpdate({
        inDriverName: formInputs.inDriverName,
        gateCode: formInputs.gateCode,
        inDate: formInputs.inDate,
        gateInwardSelectedTime: formInputs.gateInwardSelectedTime,
        inNextHour: formInputs.inNextHour,
        inCustomerName: formInputs.inCustomerName,
        inVehicleNumber: formInputs.inVehicleNumber,

        inDriverMobileNumber: formInputs.inDriverMobileNumber,
        inVehicleType: formInputs.inVehicleType,
        inWeightBridge: formInputs.inWeightBridge,
        inLoadingBay: formInputs.inLoadingBay,
        inLoadingPoints: formInputs.inLoadingPoints,
        inWeighbridge: formInputs.inWeighbridge,
        inWeighbridgeName: formInputs.inWeighbridgeName,

        gateTransportRequestNumber: formInputs.gateTransportRequestNumber,
        outPass: formInputs.outPass,
        gateOutWardDate: formInputs.gateOutWardDate,
        gateOutWardTime: formInputs.gateOutWardTime,
        outRemark: formInputs.outRemark,
        outNextHour: formInputs.outNextHour,
        outVehicleType: formInputs.outVehicleType,
        outWeightBridge: formInputs.outWeightBridge,
        outVehicleNumber: formInputs.outVehicleNumber,
        outDriverName: formInputs.outDriverName,
        outDriverMobileNumber: formInputs.outDriverMobileNumber,
        outLoadingBay: formInputs.outLoadingBay,
        outLoadingPoints: formInputs.outLoadingPoints,
        outWeighbridge: formInputs.outWeighbridge,
        // Add other fields here if needed

        invoiceNumber: formInputs.invoiceNumber,
        deliveryChallanNumber: formInputs.deliveryChallanNumber,
        ewayBillNumber: formInputs.ewayBillNumber,

        invoiceAttachmentId: formInputs.invoiceAttachmentId,
        deliveryChallanAttachmentId: formInputs.deliveryChallanAttachmentId,
        ewayBillAttachmentId: formInputs.ewayBillAttachmentId,
      });
    }
  }, [formInputs]);

  //handle update
  const handleUpdate = async () => {
    const obj = getGateUpdate;
    await ItemServiceV2.updateGateEntry(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants.LOGISTICS_IN_WORD_OUT_WORD_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  const fetchPODetailsByNr = async (poNumber) => {
    if (!poNumber) return;
    try {
      let obj = {
        module: "PO",
        queryName: "getMaterialPO",
        page: 1,
        per_page: 100,
        searchTerm: poNumber,
        timeZone: "Asia/Calcutta",
      };

      const response = await ItemService.getPurchaseOrder(obj);

      if (response?.status === 200 && response?.data) {
        // Find the specific PO and set its items
        const matchedPO = response.data.find(
          (po) =>
            po.purchasingDocumentNr === poNumber ||
            po.documentNumber === poNumber
        );
        if (matchedPO && matchedPO.items) {
          setPOItems(matchedPO.items);
        }
      }
    } catch (error) {
      console.error("Error fetching PO line items:", error);
    }
  };

  useEffect(() => {
    if (formInputs.purchasingDocumentNr && formInputs.gate === "InWard") {
      fetchPODetailsByNr(formInputs.purchasingDocumentNr);
    }
  }, [formInputs.purchasingDocumentNr, formInputs.gate]);

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">
                  Gate Entry InWard/OutWard Details{""}
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {customerID}
                  </span>
                  <span>
                    {formInputs?.gate === "InWard" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {formInputs?.gate}
                      </span>
                    ) : formInputs?.gate === "OutWard" ? (
                      <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                        {formInputs?.gate}
                      </span>
                    ) : (
                      formInputs?.gate
                    )}
                  </span>
                </h2>
                <p className="subText"> Gate Entry InWard/OutWard Details </p>
              </Col>
            </Row>
            <hr />
            <Row className="mb-4">
              {/* edit button */}
              {/* {editMode && ( */}
              <Col
                xs={6}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              >
                {/* {hasAccess(
                    userRole,
                    "buttons",
                    "customer_details_edit",
                    pageConfigInfo
                  ) && ( */}
                {/* <Col xs={6} md={2} lg={2} className="text-left">
                      <button className="btnInfo" onClick={gateEntryUpdates}>
                        Edit
                      </button>
                    </Col> */}
                {/* )} */}
              </Col>
              {/* )} */}
              {!editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className="text-left "
                  onClick={handleUpdate}
                >
                  <button className="btnInfo">Update</button>
                </Col>
              )}
              {/* {!editMode && ( */}
              {/* <Col xs={6} md={2} lg={2} className="text-left">
                  <button
                    className="btnInfo btn-danger"
                    onClick={cancelUpdate}
                  >
                    Cancel
                  </button>
                </Col> */}
              {/* )} */}
            </Row>
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={2} md={9} lg={9}>
                      <span className="headerTitle">
                        Gate Entry InWard/OutWard Details{" "}
                      </span>
                      <span className="subHeaderTitle">
                        Gate Entry InWard/OutWard Details
                      </span>
                    </Col>
                    {/* <Col xs={6} md={2} lg={2} className="text-left">
                      <button
                        className="btnInfo"
                        onClick={handlePrintGatePass}
                        style={{
                          backgroundColor: "#17a2b8",
                          borderColor: "#17a2b8",
                        }}
                      >
                        <i className="bi bi-printer me-2"></i>
                        Print Gate Pass
                      </button>
                    </Col> */}
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      {formInputs.gate === "InWard" && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Select Date"
                              name="inDate"
                              id="inDate"
                              value={formInputs?.inDate || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              label="Select Time"
                              name="gateInwardSelectedTime"
                              id="gateInwardSelectedTime"
                              value={formInputs?.gateInwardSelectedTime || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Valid for Next"
                              placeholder=""
                              name="inNextHour"
                              id="inNextHour"
                              error={validation.inNextHour || ""}
                              value={formInputs.inNextHour || ""}
                              onChange={handleInputChange}
                              required={true}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              placeholder=""
                              name="inCustomerName"
                              id="inCustomerName"
                              error={validation?.inCustomerName || ""}
                              value={formInputs?.inCustomerName || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Vehicle Number"
                              placeholder="Enter Vehicle Number"
                              name="inVehicleNumber"
                              id="inVehicleNumber"
                              error={validation.inVehicleNumber || ""}
                              // value={
                              //   formInputs.gateInwardVehicleDetails || ""
                              // }
                              value={formInputs.inVehicleNumber || ""}
                              onChange={handleInputChange}
                              required={true}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Driver Name"
                              placeholder="Enter Driver Name"
                              name="inDriverName"
                              id="inDriverName"
                              error={validation.inDriverName || ""}
                              value={formInputs.inDriverName || ""}
                              onChange={handleInputChange}
                              // required={true}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Driver Contact Number"
                              placeholder="Enter Driver Contact Number"
                              name="inDriverMobileNumber"
                              id="inDriverMobileNumber"
                              error={validation.inDriverMobileNumber || ""}
                              value={formInputs.inDriverMobileNumber || ""}
                              onChange={handleInputChange}
                              // required={true}
                              disabled={true}
                            />
                          </Col>
                          <Col xs={12} md={6} lg={3}>
                            <p>
                              <strong>Please Select Vehicle type</strong>
                            </p>
                            <div className="d-flex fs-5 fw-medium ms-3 my-3">
                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="inVehicleType"
                                    value="emptyVehicle"
                                    checked={
                                      formInputs.inVehicleType ===
                                      "emptyVehicle"
                                    }
                                    onChange={handleInputChange}
                                    disabled={true}
                                    id="emptyVehicle"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="emptyVehicle"
                                  >
                                    Empty Vehicle
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="inVehicleType"
                                    value="loadedVehicle"
                                    checked={
                                      formInputs.inVehicleType ===
                                      "loadedVehicle"
                                    }
                                    //setValue={formInputs.inVehicleType || ""}
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="loadedVehicle"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="loadedVehicle"
                                  >
                                    Loaded Vehicle
                                  </label>
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p>
                              <strong>
                                Do you want the Vehicle to proceed to weight
                                bridge
                              </strong>
                            </p>
                            <div className="d-flex fs-5 fw-medium ms-3 my-3">
                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="inWeightBridge"
                                    value="yes"
                                    checked={
                                      formInputs.inWeightBridge === "yes"
                                    }
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="weighYes"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="weighYes"
                                  >
                                    Yes
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="inWeightBridge"
                                    value="no"
                                    checked={formInputs.inWeightBridge === "no"}
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="weighNo"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="weighNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </Col> */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Loading Bay"
                              placeholder=""
                              name="inLoadingBay"
                              id="inLoadingBay"
                              error={validation.inLoadingBay || ""}
                              value={formInputs.inLoadingBay || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Loading Points"
                              placeholder=""
                              name="inLoadingPoints"
                              id="inLoadingPoints"
                              error={validation.inLoadingPoints || ""}
                              value={formInputs.inLoadingPoints || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Weighbridge"
                              placeholder=""
                              name="inWeighbridge"
                              id="inWeighbridgeName"
                              error={validation.inWeighbridgeName || ""}
                              value={formInputs.inWeighbridgeName || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="PO Number"
                              placeholder=""
                              name="purchasingDocumentNr"
                              id="purchasingDocumentNr"
                              error={validation.purchasingDocumentNr || ""}
                              value={formInputs.purchasingDocumentNr || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice Number"
                              placeholder=""
                              name="invoiceNumber"
                              id="invoiceNumber"
                              error={validation.invoiceNumber || ""}
                              value={formInputs.invoiceNumber || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          {/* Invoice File Upload with View Icon */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div className="d-flex align-items-start">
                              <div style={{ flex: 1 }}>
                                <FileUploadComponent
                                  label="Invoice Attachment"
                                  name="invoice"
                                  id="invoiceUpload"
                                  value={formInputs.invoiceAttachmentId || ""}
                                  allowedTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                  ]}
                                  multiple={false}
                                  required={false}
                                  disabled={true}
                                  onSuccessUpload={handleInvoiceUpload}
                                  extraLabel="Upload invoice document"
                                />
                              </div>

                              <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                                {formInputs.invoiceAttachmentId ? (
                                  <i
                                    className="bi bi-paperclip fs-4 text-primary"
                                    title="View Invoice"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs.invoiceAttachmentId
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                ) : (
                                  <span className="text-muted">--</span>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Delivery Challan Number"
                              placeholder=""
                              name="deliveryChallanNumber"
                              id="deliveryChallanNumber"
                              error={validation.deliveryChallanNumber || ""}
                              value={formInputs.deliveryChallanNumber || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          {/* Delivery Challan File Upload */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div className="d-flex align-items-start">
                              <div style={{ flex: 1 }}>
                                <FileUploadComponent
                                  label="Delivery Challan Attachment"
                                  name="deliveryChallan"
                                  id="deliveryChallanUpload"
                                  value={
                                    formInputs.deliveryChallanAttachmentId || ""
                                  }
                                  allowedTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                  ]}
                                  multiple={false}
                                  required={false}
                                  disabled={true}
                                  onSuccessUpload={handleDeliveryChallanUpload}
                                  extraLabel="Upload delivery challan"
                                />
                              </div>

                              <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                                {formInputs.deliveryChallanAttachmentId ? (
                                  <i
                                    className="bi bi-paperclip fs-4 text-primary"
                                    title="View Delivery Challan"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs.deliveryChallanAttachmentId
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                ) : (
                                  <span className="text-muted">--</span>
                                )}
                              </div>
                            </div>
                          </Col>
                          {/* E-way Bill Number */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div className="mb-3">
                              <InputField
                                className="inputBox"
                                label="E-way Bill Number"
                                placeholder="Enter e-way bill number"
                                name="ewayBillNumber"
                                id="ewayBillNumber"
                                value={formInputs.ewayBillNumber || ""}
                                onChange={handleInputChange}
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </Col>

                          {/* E-way Bill File Upload */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div className="d-flex align-items-start">
                              <div style={{ flex: 1 }}>
                                <FileUploadComponent
                                  label="E-way Bill Attachment"
                                  name="ewayBill"
                                  id="ewayBillUpload"
                                  value={formInputs.ewayBillAttachmentId || ""}
                                  allowedTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                  ]}
                                  multiple={false}
                                  required={false}
                                  disabled={true}
                                  onSuccessUpload={handleEwayBillUpload}
                                  extraLabel="Upload e-way bill"
                                />
                              </div>

                              <div className="d-flex align-items-center ps-2 pt-4 mt-1">
                                {formInputs.ewayBillAttachmentId ? (
                                  <i
                                    className="bi bi-paperclip fs-4 text-primary"
                                    title="View E-way Bill"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs.ewayBillAttachmentId
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                ) : (
                                  <span className="text-muted">--</span>
                                )}
                              </div>
                            </div>
                          </Col>
                        </>
                      )}
                      {formInputs.gate === "OutWard" && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Transport Request Number"
                              placeholder=""
                              name="gateTransportRequestNumber"
                              id="gateTransportRequestNumber"
                              error={
                                validation.gateTransportRequestNumber || ""
                              }
                              value={
                                formInputs.gateTransportRequestNumber || ""
                              }
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              placeholder=""
                              name="outCustomerName"
                              id="outCustomerName"
                              error={validation?.outCustomerName || ""}
                              value={formInputs?.outCustomerName || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Type Of Outpass"
                              placeholder=""
                              data={typeOfOutpass}
                              id="outPass"
                              iconClassName="dropdownIcon"
                              name="outPass"
                              code="outPass"
                              description="outPass"
                              setValue={formInputs.outPass || ""}
                              getvalue={setDropdownData}
                              disabled={true}
                              // getvalue={setDropdownData}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Select Date"
                              name="outDate"
                              id="outDate"
                              value={formInputs?.outDate}
                              onChange={handleInputChange}
                              disabled={true}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              label="Select Time"
                              name="gateOutWardTime"
                              id="gateOutWardTime"
                              value={formInputs?.gateOutWardTime}
                              onChange={handleInputChange}
                              disabled={true}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={4}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Enter Gate Remarks"
                              name="outRemark"
                              id="outRemark"
                              value={formInputs.outRemark}
                              error={validation.outRemark || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={4}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Valid for Next"
                              name="outNextHour"
                              id="outNextHour"
                              value={formInputs.outNextHour}
                              error={validation.outNextHour || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // disabled={true}
                            />
                          </Col>
                          <Col xs={2} md={3} lg={3}>
                            <p>
                              <strong>Please Select Vehicle type</strong>
                            </p>
                            <div className="d-flex fs-5 fw-medium ms-3 my-3">
                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="outVehicleType"
                                    value="emptyVehicle"
                                    checked={
                                      formInputs.outVehicleType ===
                                      "emptyVehicle"
                                    }
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="emptyVehicle"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="emptyVehicle"
                                  >
                                    Empty Vehicle
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="outVehicleType"
                                    value="loadedVehicle"
                                    checked={
                                      formInputs.outVehicleType ===
                                      "loadedVehicle"
                                    }
                                    //setValue={formInputs.outVehicleType || ""}
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="loadedVehicle"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="loadedVehicle"
                                  >
                                    Loaded Vehicle
                                  </label>
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col
                            xs={2}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p>
                              <strong>
                                Do you want the Vehicle to proceed to weight
                                bridge
                              </strong>
                            </p>
                            <div className="d-flex fs-5 fw-medium ms-3 my-3">
                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="outWeightBridge"
                                    value="yes"
                                    checked={
                                      formInputs.outWeightBridge === "yes"
                                    }
                                    disabled={true}
                                    onChange={handleInputChange}
                                    id="weighYes"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="weighYes"
                                  >
                                    Yes
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex align-items-center me-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="outWeightBridge"
                                    value="no"
                                    disabled={true}
                                    checked={
                                      formInputs.outWeightBridge === "no"
                                    }
                                    onChange={handleInputChange}
                                    id="weighNo"
                                  />
                                  <label
                                    className="form-check-label fs-5"
                                    htmlFor="weighNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Vehicle Number"
                              placeholder="Enter Vehicle Number"
                              name="outVehicleNumber"
                              id="outVehicleNumber"
                              error={validation.outVehicleNumber || ""}
                              // value={
                              //   formInputs.outVehicleNumber || ""
                              // }
                              value={formInputs.outVehicleNumber || ""}
                              disabled={true}
                              onChange={handleInputChange}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Driver Name"
                              placeholder="Enter Driver Name"
                              name="outDriverName"
                              id="outDriverName"
                              error={validation.outDriverName || ""}
                              value={formInputs.outDriverName || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Enter Driver Contact Number"
                              placeholder="Enter Driver Contact Number"
                              name="outDriverMobileNumber"
                              id="outDriverMobileNumber"
                              error={validation.outDriverMobileNumber || ""}
                              value={formInputs.outDriverMobileNumber || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Loading Bay"
                              placeholder=""
                              name="outLoadingBay"
                              id="outLoadingBay"
                              error={validation.outLoadingBay || ""}
                              value={formInputs.outLoadingBay || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Loading Points"
                              placeholder=""
                              name="outLoadingPoints"
                              id="outLoadingPoints"
                              error={validation.outLoadingPoints || ""}
                              value={formInputs.outLoadingPoints || ""}
                              disabled={true}
                              onChange={handleInputChange}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Weighbridge"
                              placeholder=""
                              name="outWeighbridge"
                              id="outWeighbridge"
                              error={validation.outWeighbridge || ""}
                              value={formInputs.outWeighbridge || ""}
                              onChange={handleInputChange}
                              disabled={true}
                              // required={true}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                    {/* --- PO Items Table Section --- */}
                    {formInputs.gate === "InWard" && poItems.length > 0 && (
                      <Row className="mt-4 mb-3 px-2">
                        <Col xs={12} className="p-3 border rounded bg-light">
                          <h6 className="fw-bold mb-3">
                            <i className="bi bi-list-task me-2"></i>
                            Purchase Order Items -{" "}
                            {formInputs.purchasingDocumentNr}
                          </h6>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover mb-0 bg-white">
                              <thead className="table-light">
                                <tr style={{ fontSize: "14px" }}>
                                  <th className="text-center">Material Code</th>
                                  <th>Description</th>
                                  <th className="text-center">Quantity</th>
                                  <th className="text-center">UOM</th>
                                  <th>Plant/Location</th>
                                </tr>
                              </thead>
                              <tbody style={{ fontSize: "13px" }}>
                                {poItems.map((item, index) => (
                                  <tr key={index}>
                                    <td className="text-center fw-bold">
                                      {item.materialCode || "-"}
                                    </td>
                                    <td>{item.materialDescription || "-"}</td>
                                    <td className="text-center">
                                      {item.purchaseQuantity || "0"}
                                    </td>
                                    <td className="text-center">
                                      {item.orderUnitOfMeasure || "-"}
                                    </td>
                                    <td>{item.storageLocation || "-"}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* 02 */}
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item"> */}
            {/* <h2 className="accordion-header">
                  <Row className="accordion-button"> */}
            {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col> */}

            {/* <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Admin Details</span>
                      <span className="subHeaderTitle">
                        Admin Details
                      </span>
                    </Col> */}
            {/* </Row>
                </h2> */}

            {/* </div>
            </div> */}
          </div>

          <div style={{ display: "none" }}>
            <PrintGatePass ref={printGatePassRef} data={formInputs} />
          </div>
          <FailureModal
            show={getShowFailureModal}
            onHide={hideFailureModal}
            failureStockData={getFailureCashRequestUpdate}
          />
          <FileViewerModal
            show={getShowFileViewModal}
            onHide={handleViewFileHide}
            fileid={getFileViewData}
          />
        </Col>
      </Row>
    </main>
  );
};

export default GateEntryUpdate;
